// ข้อมูลเสริมใน presence (stores/{id}/online/{computerUuid}) ไว้ให้คนอ่านใน Firebase console
// ตอนไล่เคส "เครื่องแปลก ๆ โผล่ออนไลน์" — เช่น tab เก่าบนมือถือที่ค้างไว้เป็นสัปดาห์
// แล้วเบราว์เซอร์ปลุกขึ้นมาแป๊บ ๆ (startedAt รีเซ็ตทุกรอบ reconnect เลยดูอายุ tab จากนั้นไม่ได้)

import dayjs from "dayjs";

/** เวลาที่ tab นี้โหลดหน้า (epoch ms) — ไม่รีเซ็ตตอน reconnect ต่างจาก startedAt */
export const PAGE_LOADED_AT_MS = Math.round(
  typeof performance !== "undefined" && performance.timeOrigin ? performance.timeOrigin : Date.now()
);

/** ms → "5h 35m" / เกินวัน "6d 5h 35m" — ละเอียดระดับนาที (heartbeat ทุก 1 นาที) */
export function formatDuration(ms: number): string | null {
  if (!Number.isFinite(ms)) return null;
  const totalMinutes = Math.max(0, Math.floor(ms / 60_000));
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = totalMinutes % 60;
  return `${days ? `${days}d ` : ""}${hours}h ${minutes}m`;
}

/**
 * มือถือ / แท็บเล็ตไหม — เดาจากหลายสัญญาณเพราะโหมด desktop ของเบราว์เซอร์มือถือปลอม user agent
 * iPhone / iPad โหมด desktop บอกตัวเองเป็น Macintosh แต่ Mac จริงไม่มีจอสัมผัส
 * Android โหมด desktop บอกเป็น Linux จับไม่ได้ ดู screen / touchPoints ประกอบ
 * (เครื่อง POS จอสัมผัสก็มี touchPoints จึงใช้ touch อย่างเดียวตัดสินไม่ได้)
 */
function detectMobile(): boolean {
  const nav = navigator as Navigator & { userAgentData?: { mobile?: boolean } };
  if (nav.userAgentData?.mobile === true) return true;
  const ua = nav.userAgent || "";
  if (/Android|iPhone|iPad|iPod|Mobile/i.test(ua)) return true;
  return /Macintosh/.test(ua) && nav.maxTouchPoints > 1;
}

/** ส่วนของ payload heartbeat ที่บอกว่าเครื่อง / tab นี้คืออะไร อยู่ตรงไหน */
export function getPresenceDeviceInfo() {
  return {
    pageLoadedAt: dayjs(PAGE_LOADED_AT_MS).format(),
    pageAgeFor: formatDuration(Date.now() - PAGE_LOADED_AT_MS),
    userAgent: navigator.userAgent || null,
    isMobile: detectMobile(),
    touchPoints: navigator.maxTouchPoints ?? 0,
    screen: `${screen.width}x${screen.height}@${window.devicePixelRatio || 1}`,
    route: window.location.pathname,
    // hidden = tab อยู่เบื้องหลัง / จอดับ — ไม่มีใครใช้อยู่
    visibility: document.visibilityState,
  };
}
